/* eslint-disable max-lines */
/*
 * @FilePath: \kitchen-online-web\src\3DEngine\render\renderTypes\renderBaseType.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-21 13:35:42
 * @LastEditors: Zhanyu Shen
 * @LastEditTime: 2022-05-11 10:25:17
 */

import { LengthType, BASICTYPE_ENUM, BASICRENDER_TYPE } from '../utils/enum';
import SidePlate from '../specialHandler/sidePlate';
import SkirtingBoard from '../specialHandler/skirtingBoard';
import MeshManage from '../meshManage';
import VoxtorpDoor from '../specialHandler/voxtorpDoor';
import {
  FRAMEDEPTH,
  TYPECODE,
  BOTTOMSIDENAME,
  TOPSIDENAME,
  FRAMESTYPE,
  SKIRTINGBOARDCONFIG,
  TOPHIGHTFRAMESEPARATEDLENGTH,
  VERSION_2_1,
} from '../utils/kitchenConfig';
import {
  checkFrameIsHighFrame,
  checkHasHightFrameByPosition,
  checkHasRefrigerarorByPosition,
  getHightFrameLengthByPosition,
  getRefrigerarorWidthByPosition,
} from '../utils/renderUtils';
import SealPlate from '../specialHandler/sealPlate';
import LengthX from '../lengthTypes/lengthX';
import LengthZ from '../lengthTypes/lengthZ';
import LengthP2X from '../lengthTypes/lengthP2X';
import RenderGroupMesh from './renderGroupMesh';
import RenderVersion from '../utils/renderVersion';

class RenderBaseType extends RenderGroupMesh {
  handleSealPlate(type) {
    this.renderSealPlate(type);
  }

  /**
   * @description: 改变templateJson
   * @param {*} templateJson
   * @return {*}
   * @author: Yongchao Wang
   */
  changeTemplateJson(templateJson) {
    this.templateJson = templateJson;
    this.handleBottomFrames(templateJson.bottom);
    this.handleTopFrames(templateJson.top);
  }

  addSidePlatesMeshes(sidePlatesArray) {
    sidePlatesArray.forEach((element) => {
      if (element) {
        this.addMesh(this.scene.getMeshByName(element.id));
      }
    });
  }

  /**
   * @description: 将柜子和柜门组合起来
   * @param {*} frame 柜子框架
   * @param {*} doors 柜门
   * @param {*} isbottom 是否底柜
   * @param {*} frameAllInfo 整个柜子的对象
   * @return {*}
   * @author: Yongchao Wang
   */
  groupMeshsFrameDoors(frame, doors, isbottom, frameAllInfo) {
    super.groupMeshsFrameDoors(frame, doors, isbottom, frameAllInfo);
  }

  /**
   * @description: 将高柜柜子和柜门组合起来
   * @param {*} frame 高柜
   * @param {*} doors 柜门
   * @param {*} location 顶柜还是底柜
   * @return {*}
   * @author: Yongchao Wang
   */
  groupMeshsHighFrameDoors(frameComponent, doors, location) {
    // 一期顶柜空高柜
    if (!doors) {
      return;
    }
    // 版本兼容 2.1版本门板顺序调整了，小于2.1的走原渲染方式
    if (
      RenderVersion.checkOldRenderVersion(
        this?.templateJson?.version,
        VERSION_2_1,
      )
    ) {
      const renderVersion = new RenderVersion(this);
      renderVersion.oldFunGroupMeshsHighFrameDoors(
        frameComponent,
        doors,
        location,
      );
    } else {
      super.groupMeshsHighFrameDoors(frameComponent, doors, location);
    }
  }

  /**
   * @description: 单独处理高柜的门板
   * @param {*} parent 父mesh
   * @param {*} child 子mesh
   * @param {*} doors 门板数组
   * @param {*} categoryId 类别id
   * @param {*} index 索引
   * @return {*}
   * @author: Yongchao Wang
   */
  handleHighFrameDoorPlanks(parent, child, doors, categoryId, index) {
    super.handleHighFrameDoorPlanks(parent, child, doors, categoryId, index);
  }

  /**
   * @description: 将水槽和水槽柜、水龙头组合起来，并将水槽设置到合理位置
   * @param {*} frame 柜子
   * @param {*} sink 水槽
   * @return {*}
   * @author: Yongchao Wang
   */
  groupMeshsFrameSink(frame, sink) {
    super.groupMeshsFrameSink(frame, sink);
  }

  /**
   * @description: 将燃气灶和柜子组合起来
   * @param {*} frame 柜子
   * @param {*} stove 燃气灶
   * @return {*}
   * @author: Yongchao Wang
   */
  groupMeshsFrameStove(frame, stove) {
    super.groupMeshsFrameStove(frame, stove);
  }

  /**
   * @description: 渲染油烟机和调整油烟机的顶柜
   * @param {*} element 整个frame对象
   * @return {*}
   * @author: Yongchao Wang
   */
  renderVentilator(element, rotation) {
    super.renderVentilator(element, rotation);
  }

  /**
   * @description: 组合门板和把手
   * @param {*} frame 柜子信息
   * @param {*} e 门板信息
   * @param {*} child 门板对象
   * @param {*} isbottom 是否是底柜
   * @param {*} isHighFrame 是否是高柜
   * @return {*}
   * @author: Yongchao Wang
   */
  groupMeshsDoorHandle(frame, e, child, isbottom, isHighFrame = false) {
    super.groupMeshsDoorHandle(frame, e, child, isbottom, isHighFrame);
  }

  /**
   * @description: 清除所有的mesh
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  clearAllMeshed() {
    this?.skirtingBoard.forEach((e) => {
      e.mesh.dispose();
      this.scene.removeMesh(e.mesh);
    });
    this.skirtingBoard = [];
    this.topPanelMesh.forEach((e) => {
      e?.dispose();
      this?.scene?.removeMesh(e);
    });
    this.topPanelObjs = [];

    this.topPanelMesh = [];
    this?.allMeshes.forEach((e) => {
      e?.dispose();
      this.scene.removeMesh(e);
    });
    this.allMeshes = [];
    this?.roomMeshes?.forEach((e) => {
      e?.dispose();
      this.scene.removeMesh(e);
    });
    this.roomMeshes = [];

    this.rotationMeshes = {};
  }

  /**
   * @description: 删除componentBasic数组中的mesh
   * @param {*} componentBasicArray
   * @return {*}
   * @author: Yongchao Wang
   */
  removeMeshes(componentBasicArray) {
    componentBasicArray.forEach((e) => {
      if (!e?.componentBasic) {
        return;
      }
      const mesh = this.scene.getMeshByName(e.componentBasic.id);
      mesh.dispose();
      this.scene.removeMesh(mesh);
    });
  }

  addMesh(mesh) {
    if (!mesh) {
      return;
    }
    this.allMeshes.push(mesh);
  }

  getWindowFrame(location, length) {
    let lengthEdge = length;
    const { frames } = this.templateJson[location][length];
    if (!frames && frames.length === 0) {
      return {};
    }
    let frame;
    let window;
    frames.forEach((e) => {
      if (e.window) {
        frame = e;
        window = e.window;
        if (e.longEdge) {
          lengthEdge = `length${e.longEdge}`;
        }
      }
    });

    return { frame, length: lengthEdge, window };
  }

  /**
   * @description: 改变墙颜色
   * @param {*} materialUrl
   * @return {*}
   * @author: Yongchao Wang
   */
  changeWallColor(wallTextureUrl, wallNormalTextureUrl, size) {
    this.bottomLength1.changeWallColor(
      wallTextureUrl,
      wallNormalTextureUrl,
      size,
    );
    this.bottomLength2?.changeWallColor(
      wallTextureUrl,
      wallNormalTextureUrl,
      size,
    );
    this.bottomLength3?.changeWallColor(
      wallTextureUrl,
      wallNormalTextureUrl,
      size,
    );
    this.bottomLength4?.changeWallColor(
      wallTextureUrl,
      wallNormalTextureUrl,
      size,
    );
  }

  getCalloutLineInfo() {
    return this.calloutLineInfo;
  }

  /**
   * @description: 处理顶柜的逻辑，将底柜框架和门板组合起来，并形成一个mesh的Map暴露出来。
   * @param {*}
   * @return {*} 返回一个mesh的Map
   * @author: Yongchao Wang
   */
  handleTopFrames(top) {
    super.handleTopFrames(top);
  }

  /**
   * @description: 处理底柜的逻辑，将底柜框架和门板组合起来，并形成一个mesh的Map暴露出来。
   * @param {*}
   * @return {*} 返回一个mesh的Map
   * @author: Yongchao Wang
   */
  handleBottomFrames(bottom) {
    super.handleBottomFrames(bottom);
  }

  /**
   * @description: 改变mesh 水槽position使用水槽顶部
   * @param {*} templateJson 完整的templateJson
   * @param {*} changeMap 改变的门板内容{old:[{componentBasic:xxx,relativeLocation:xxx}],new:[xxx]}
   * @param {*} isSink 是否是水槽
   * @param {*} isFaucet 是否是水龙头
   * @return {*}
   * @author: Yongchao Wang
   */
  replaceMeshes(templateJson, changeMap, isSink, isFaucet) {
    // debugger;
    if (
      !templateJson
      || !changeMap
      || (changeMap.old && changeMap.old.length !== changeMap.new.length)
    ) {
      return;
    }
    this.templateJson = templateJson;
    const positions = [];
    const scalings = [];
    const sealcalings = []; // 存储补板缩放数据
    const parents = [];
    const oldSizes = [];
    // const children = [];
    if (changeMap.old) {
      changeMap.old.forEach((element) => {
        if (
          !element?.componentBasic
          || !element.componentBasic.show
          || !element.componentBasic.modelUrl
        ) {
          positions.push(undefined);
          scalings.push(undefined);
          parents.push(undefined);
          return;
        }
        const child = this.scene.getMeshByName(element.componentBasic.id);
        if (!child) {
          console.error(element.componentBasic.id);
          return;
        }
        const { parent, position } = child;
        // 把台面销毁重新创建并挖洞
        if (isSink) {
          const meshManage = new MeshManage(child);
          position.y += meshManage?.getModelSize()?.y;
        }
        if (isFaucet) {
          const meshManage = new MeshManage(child);
          oldSizes.push(meshManage.getModelSize());
        }
        if (
          TYPECODE.SIDEPLATEANDSEALPLATE(element.componentBasic.typeCode)
          && !element.componentBasic?.showType
        ) {
          const scalingMeshManage = new MeshManage(child);
          scalings.push({
            x: scalingMeshManage?.getModelSize()?.x,
            y: scalingMeshManage?.getModelSize()?.y,
            z: scalingMeshManage?.getModelSize()?.z,
          });
        } else {
          scalings.push(undefined);
        }
        if (element.componentBasic?.showType) {
          const scalingMeshManage = new MeshManage(child);
          sealcalings.push({
            x: scalingMeshManage?.getModelSize()?.x,
            y: scalingMeshManage?.getModelSize()?.y,
            z: scalingMeshManage?.getModelSize()?.z,
          });
        } else {
          sealcalings.push(undefined);
        }
        parent?.removeChild(child);
        child.dispose();
        this.scene.removeMesh(child);
        positions.push(position);
        parents.push(parent);
      });
    }
    if (changeMap.new) {
      changeMap.new.forEach((element, index) => {
        this.addMesh(
          new MeshManage(this.scene.getMeshByName(element.componentBasic.id))
            .mesh,
        );
        if (!element.componentBasic.show || !element.componentBasic.modelUrl) {
          return;
        }
        const child = this.scene.getMeshByName(element.componentBasic.id);
        const oldElementId = changeMap.old[index].componentBasic.id;
        const rotation = this.rotationMeshes[oldElementId];
        // debugger;
        if (rotation) {
          child.addRotation(rotation.x, rotation.y, rotation.z);
          this.rotationMeshes[element.componentBasic.id] = rotation;
        }
        const parent = parents[index];
        child.position = positions[index];
        if (scalings[index]) {
          const sidePlate = new SidePlate(new MeshManage(child));
          sidePlate.rollBackAfterReplace(rotation, scalings[index]);
        }

        if (sealcalings[index]) {
          const scalingMeshManage = new MeshManage(child);
          SealPlate.setChangeDoorScale(
            scalingMeshManage,
            rotation,
            sealcalings[index],
          );
        }

        if (isSink) {
          this.sinkMesh = child;
          const meshManage = new MeshManage(child);

          child.position.y -= meshManage?.getModelSize()?.y;
          if (element.faucet) {
            const faucetMesh = this.scene.getMeshByName(
              changeMap.old[index].faucet.componentBasic.id,
            );
            faucetMesh.name = element.faucet.componentBasic.id;
          }
        }
        const parentRotation = this.rotationMeshes[parent?.name];
        // 子类继承父类旋转， 转角柜补板存在自身旋转不与父级去做旋转
        if (parentRotation && element.componentBasic?.showType !== 2) {
          child.addRotation(
            parentRotation.x,
            parentRotation.y,
            parentRotation.z,
          );
          this.rotationMeshes[parent.name] = parentRotation;
        }
        if (
          changeMap.position === 'top'
          && changeMap.type === 'L'
          && index === 0
        ) {
          child.addRotation(0, -Math.PI / 2, 0);
        }
        if (isFaucet) {
          const meshManage = new MeshManage(child);
          const oldSize = oldSizes[index];
          switch (parentRotation?.y ?? 0) {
            case 0:
              child.position.z
                += meshManage.getModelSize().z / 2 - oldSize.z / 2;
              break;
            case -Math.PI / 2:
              child.position.x
                -= meshManage.getModelSize().x / 2 - oldSize.x / 2;
              break;
            case -Math.PI:
              child.position.z
                -= meshManage.getModelSize().z / 2 - oldSize.z / 2;
              break;
            default:
              break;
          }
        }

        parent?.addChild(child);
      });
    }
  }

  /**
   * @description: 在替换门板之前，旋转沃拓普
   * @param {*} changeMap
   * @param {*} needMoveUp
   * @return {*}
   * @author: Yongchao Wang
   */
  rotationVoxtorpAfterReplaceDoors(changeMap, needMoveUp) {
    changeMap.new.forEach((element) => {
      if (!element.componentBasic.show || !element.componentBasic.modelUrl) {
        return;
      }
      const childMesh = this.scene.getMeshByName(element.componentBasic.id);
      const child = new MeshManage(childMesh);
      const voxtorpDoor = new VoxtorpDoor(
        undefined,
        element,
        child,
        this.scene,
      );
      voxtorpDoor.rotateTopDoor(needMoveUp);
    });
  }

  /**
   * @description: 从沃拓普替换到普通门板，下移普通门板
   * @param {*} changeMap
   * @return {*}
   * @author: Yongchao Wang
   */
  downNormalDoorsAfterReplaceDoors(changeMap) {
    changeMap.new.forEach((element) => {
      if (!element.componentBasic.show || !element.componentBasic.modelUrl) {
        return;
      }
      const childMesh = this.scene.getMeshByName(element.componentBasic.id);
      const child = new MeshManage(childMesh);
      const { position } = childMesh;

      child.setModelPosition({
        x: position.x,
        y: position.y - child.getModelSize().y,
        z: position.z,
      });
    });
  }

  /**
   * @description: 删除对应的mesh
   * @param {*} meshesArray
   * @return {*}
   * @author: Yongchao Wang
   */
  deleteMeshes(meshesArray) {
    meshesArray.forEach((element) => {
      const child = this.scene.getMeshByName(element.componentBasic.id);

      const { parent } = child;
      parent?.removeChild(child);
      child.dispose();
      this.scene.removeMesh(child);
    });
  }

  /**
   * @description: 修改台面材质
   * @param {*} texture 材质
   * @return {*}
   * @author: Yongchao Wang
   */
  async changeTopPanelTexture(texture) {
    for (let i = 0; i < this.topPanelObjs.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      await this.topPanelObjs[i].changeTexture(texture);
    }
    // this.topPanelObjs.forEach((e) => {
    //   e.changeTexture(texture);
    // });
  }

  /**
   * @description: 修改踢脚板材质
   * @param {*} texture 材质
   * @return {*}
   * @author: Yongchao Wang
   */
  changeSkritingTexture(texture) {
    this.skirtingBoard.forEach((e) => {
      e.changeTexture(texture);
    });
  }

  /**
   * @param {string} type 类型 bootom/top
   * @returns {object} {}
   * @description 获取每条length补板数据，组合成对象返回，key为length
   */
  getLengthSealPlate(type) {
    const data = this?.templateJson?.[type];
    const frameList = type === FRAMESTYPE.bottom ? BOTTOMSIDENAME : TOPSIDENAME;
    const sealPlateData = {};
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < frameList.length; index++) {
      const element = data[`${frameList[index]}`];
      sealPlateData[`${frameList[index]}`] = element?.sealPlate || [];
    }
    return sealPlateData;
  }

  renderSealPlate(type) {
    // 获取每条边额补板数据
    const sealPlateData = this.getLengthSealPlate(type);
    // 获取每条边最后一个柜体
    // const lengthBase = new BaseLength(this.templateJson, this.scene, null);
    // 补板实例
    // const sealPlateBase = new SealPlate(this.scene);
    Object.keys(sealPlateData).forEach((lengthType) => {
      // length没有补板数据
      // eslint-disable-next-line no-unused-vars
      // const lastFrameData = this?.templateJson?.bottom[lengthType]?.frames.slice(-1);
      if (!Object.keys(sealPlateData[lengthType]).length) {
        return;
      }

      let renderObj = '';
      switch (lengthType) {
        case LengthType.Length1:
          renderObj = new LengthX(this.templateJson, this.scene);
          renderObj.renderSealPlate(sealPlateData[lengthType], type);
          break;
        case LengthType.Length2:
          renderObj = new LengthZ(this.templateJson, this.scene);
          renderObj.renderSealPlate(sealPlateData[lengthType], type);
          break;
        case LengthType.Length3:
          renderObj = new LengthP2X(this.templateJson, this.scene);
          renderObj.renderSealPlate(sealPlateData[lengthType], type);
          break;
        default:
          break;
      }
      // 添加进mesh容器，清除mesh使用
      sealPlateData[lengthType].forEach((item) => {
        this.addMesh(this.scene.getMeshByName(item.id));
      });

      // const lastLenghMesh = this.getLastMeshMaage('bottom', lengthType);
      // const lastLenghMesh = lengthBase.getLastMeshMaage('bottom', lengthType);
      // TODO 获取最后一个柜体的位置
      // const lastPos = {
      //   x: lastLenghMesh?.mesh?.position?.x,
      //   y: lastLenghMesh?.mesh?.position?.y,
      //   z: lastLenghMesh?.mesh?.position?.z,
      // };

      // // 缩放补板宽度
      // sealPlateBase.setSealPlatesScale('x', sealPlateData[lengthType]);
      // // 渲染补板
      // sealPlateData[lengthType].forEach((item, index) => {
      //   // 重新取模型数据
      //   let frontScaleMeshManage = new MeshManage(this.scene.getMeshByName(item.id));
      //   this.allMeshes.push(new MeshManage(this.scene.getMeshByName(item.id)).mesh);

      //   if (lengthType === BASICLENGTHTYPE_ENUM.length2) {
      //     // lenth2进行旋转
      //     lengthBase.setMeshRotate(new Vector3(0, Math.PI / 2, 0), frontScaleMeshManage);
      //     // 旋转后需要重新获取才能拿到旋转后的坐标定位数据
      //     frontScaleMeshManage = new MeshManage(this.scene.getMeshByName(item.id));
      //   }

      //   // 方向
      //   const vector = index === 0 ? AXES_TYPE.font : AXES_TYPE.back;
      //   // 根据length边渲染补板
      //   sealPlateBase.setSealPlatePos(lengthType, lastLenghMesh, frontScaleMeshManage, vector, lastPos);

      //   // const lasetHightFramesMesh = new MeshManage(this.scene.getMeshByName(lastFrameData[0].componentBasic.id));
      //   // frontScaleMeshManage = new MeshManage(this.scene.getMeshByName(item.id));
      //   // console.log('frontScaleMeshManage', frontScaleMeshManage.getModelSize().x);
      //   // lasetHightFramesMesh.setModelPosition({
      //   //   x: lasetHightFramesMesh.mesh.position.x - frontScaleMeshManage.getModelSize().x * 0.5,
      //   //   y: lasetHightFramesMesh.mesh.position.y,
      //   //   z: lasetHightFramesMesh.mesh.position.z,
      //   // });
      // });
    });
  }

  showWindow(show) {
    this?.bottomLength1?.showWindow(show);
    this?.bottomLength2?.showWindow(show);
    this?.bottomLength3?.showWindow(show);
    this?.bottomLength4?.showWindow(show);
  }

  showRoom(show) {
    this?.roomMeshes?.forEach((item) => {
      item?.setEnabled(show);
    });
  }

  changeWall(wallInfo) {
    this?.bottomLength1?.changeWallColor(
      wallInfo.baseModelUrl,
      wallInfo.normalModelUrl,
      { width: wallInfo.width * 0.001, height: wallInfo.height * 0.001 },
    );
    this?.bottomLength2?.changeWallColor(
      wallInfo.baseModelUrl,
      wallInfo.normalModelUrl,
      { width: wallInfo.width * 0.001, height: wallInfo.height * 0.001 },
    );
    this?.bottomLength3?.changeWallColor(
      wallInfo.baseModelUrl,
      wallInfo.normalModelUrl,
      { width: wallInfo.width * 0.001, height: wallInfo.height * 0.001 },
    );
    this?.bottomLength4?.changeWallColor(
      wallInfo.baseModelUrl,
      wallInfo.normalModelUrl,
      { width: wallInfo.width * 0.001, height: wallInfo.height * 0.001 },
    );
  }

  changeGround(groundInfo) {
    this.groundNode.changeMaterial(
      groundInfo.baseModelUrl,
      groundInfo.normalModelUrl,
      { width: groundInfo.width * 0.001, height: groundInfo.height * 0.001 },
    );
  }

  /**
   * @description: 获取补板指定向量尺寸值
   * @param {*} position 补板位置（底柜/顶柜）
   * @param {*} lengthNum 补板在哪条边
   * @param {*} vector 需要获取补板的哪个向量
   * @return {*}
   * @author: add by Zhanyu Shen 20211227
   */
  getSealPlateSize(position, lengthNum, vector) {
    let sealPlateVectorSize = 0;
    const lengthJson = this.templateJson[position][lengthNum];
    if (lengthJson.sealPlate) {
      const [sealPlateJson] = lengthJson.sealPlate;
      if (sealPlateJson && sealPlateJson.id) {
        const sealPlateMesh = new MeshManage(
          this.scene.getMeshByName(sealPlateJson.id),
        );
        sealPlateVectorSize = sealPlateMesh?.getModelSize()[vector];
      }
    }
    return sealPlateVectorSize;
  }

  /**
   * @description: 当L1只有一个柜子时，L2和L3没有柜子（L2只有转角柜，转角柜是在length1里所以L2柜子数为0,
   * L3的转角柜在length2里）渲染补板会影响到台面侧板踢脚线, 根据位置（底柜/顶柜）, 哪条边 , 获取所在位置的补板指定向量尺寸值
   * @param {*} position 补板位置（底柜/顶柜）
   * @param {*} lengthNum 补板在哪条边
   * @param {*} vector 需要获取补板的哪个向量
   * @return {*} 获取所在位置的补板指定向量尺寸值
   * @author: add by Zhanyu Shen 20211221
   */
  getSealPlateSizeOnlyOneFrame(position, lengthNum, vector) {
    const positionJson = this.templateJson[position];
    const lengthJson = positionJson?.[lengthNum];
    const lTypeLengthRlength = lengthJson?.rlength;
    let sealPlateSize = 0;
    // Length1至少有一个转角柜，其他边没有柜子时补板放在最后面，这时影响台面侧板踢脚线尺寸和位置
    // II型底柜（L1=65,L2=75)&II型顶柜（L1=L2=240),L3添加一个高柜,75=60柜子+15补板
    if (
      ((lengthNum === LengthType.Length1 && lengthJson.frames?.length === 1)
        || (positionJson?.type === BASICRENDER_TYPE.H
          && lengthNum === LengthType.Length3
          && lengthJson.frames?.length === 1)
        || lengthJson.frames?.length === 0)
      && lTypeLengthRlength > 0
    ) {
      sealPlateSize = this.getSealPlateSize(position, lengthNum, vector);
    }
    return sealPlateSize;
  }

  /**
   * @description: 当顶柜有高柜（只有顶柜长度比底柜大时顶柜才会有高柜）且有otherSealPlateLength（该值不为空说明底柜和高柜之间的空隙需要补板填充）,
   *  补板会在高柜前面，渲染补板会影响到台面侧板踢脚线
   * @param {*} lengthNum 高柜在哪条边
   * @param {*} hasHightFrame 调用前是否已经知道顶柜有高柜，默认没有
   * @return {*} Boolean 高柜前是否需要补板
   * @author: add by Zhanyu Shen 20211227
   */
  isSealPlateBeforeTopHightFrame(lengthNum, hasHightFrame = false) {
    const bottomLengthJson = this.templateJson.bottom[lengthNum];
    const otherSealPlateLength = bottomLengthJson?.otherSealPlateLength;
    let isNeedSealPlate = false;
    if (
      otherSealPlateLength
      && (hasHightFrame
        || checkHasHightFrameByPosition(
          this.templateJson,
          BASICTYPE_ENUM.top,
          lengthNum,
        ))
    ) {
      isNeedSealPlate = true;
    }
    return isNeedSealPlate;
  }

  /**
   * @description: 当顶柜有冰箱（只有顶柜长度比底柜大时顶柜才会有冰箱）且有otherSealPlateLength（该值不为空说明底柜和冰箱之间的空隙需要补板填充）,
   *  补板会在冰箱前面，渲染补板会影响到台面侧板踢脚线
   * @param {*} lengthNum 冰箱在哪条边
   * @param {*} hasRefrigeraror 调用前是否已经知道顶柜有冰箱，默认没有
   * @return {*} Boolean 冰箱前是否需要补板
   * @author: add by Zhanyu Shen
   */
  isSealPlateBeforeTopRefrigeraror(lengthNum, hasRefrigeraror = false) {
    const bottomLengthJson = this.templateJson.bottom[lengthNum];
    const otherSealPlateLength = bottomLengthJson?.otherSealPlateLength;
    let isNeedSealPlate = false;
    if (
      otherSealPlateLength
      && (hasRefrigeraror
        || checkHasRefrigerarorByPosition(
          this.copyTemplateJson,
          BASICTYPE_ENUM.top,
          lengthNum,
        ))
    ) {
      isNeedSealPlate = true;
    }
    return isNeedSealPlate;
  }

  /**
   * @description: 检查底柜和顶柜高柜是否分离，当顶柜长度-底柜长度-顶柜里高柜总长-冰箱长度 > 20 时，高柜不与底柜相连，需要给高柜新建三块踢脚板
   * @param {*} lengthNum 检查哪条边
   * @return {*}
   * @author: add by Zhanyu Shen 20211228
   */
  checkTopHightFrameIsSeparated(lengthNum) {
    const bottomLengthJson = this.templateJson.bottom[lengthNum];
    const bottomLength = Number(bottomLengthJson?.length);
    const topLengthJson = this.templateJson.top[lengthNum];
    const topLength = Number(topLengthJson?.length);
    if (
      topLength
        - bottomLength
        - getHightFrameLengthByPosition(
          this.templateJson,
          BASICTYPE_ENUM.top,
          lengthNum,
        )
        - getRefrigerarorWidthByPosition(
          this.copyTemplateJson,
          BASICTYPE_ENUM.top,
          lengthNum,
        )
      > TOPHIGHTFRAMESEPARATEDLENGTH
    ) {
      return true;
    }
    return false;
  }

  /**
   * @description: 获取多个高柜的整体中心坐标和尺寸
   * @param {*} position 高柜位置（底柜/顶柜）
   * @param {*} lengthNum 高柜在哪条边
   * @return {*} 高柜组的坐标和尺寸
   * @author: Zhanyu Shen
   */
  getHighFrameGroupPositionAndSize(position, lengthNum) {
    const lengthJson = this.templateJson[position][lengthNum];
    const positonAndSize = {
      position: null,
      size: null,
    };
    if (lengthJson && lengthJson.frames) {
      // 目前安装最多2个高柜，且2个高柜只能放在一起，不能放在不同边，放在边的最后位置
      const highFrameMeshs = [];
      lengthJson.frames.forEach((item) => {
        if (
          item.name
          && checkFrameIsHighFrame(item)
          && item.componentBasic?.id
        ) {
          const highFrameMesh = new MeshManage(
            this.scene.getMeshByName(item.componentBasic.id),
          );
          if (highFrameMesh) {
            highFrameMeshs.push(highFrameMesh);
          }
        }
      });
      if (highFrameMeshs.length > 1) {
        // 计算两个连接的高柜中心坐标和尺寸
        const firstHighFrame = highFrameMeshs[0];
        const lastHighFrame = highFrameMeshs[highFrameMeshs.length - 1];
        const firstHighFramePosition = firstHighFrame.getPosition();
        const firstHighFrameSize = firstHighFrame.getModelSize();
        const lastHighFramePosition = lastHighFrame.getPosition();
        const lastHighFrameSize = lastHighFrame.getModelSize();
        positonAndSize.position = {
          x:
            (firstHighFramePosition.x
              + firstHighFrameSize.x / 2
              + (lastHighFramePosition.x - lastHighFrameSize.x / 2))
            / 2,
          y: lastHighFramePosition.y,
          z: lastHighFramePosition.z,
        };
        positonAndSize.size = {
          x: firstHighFrameSize.x + lastHighFrameSize.x,
          y: Math.max(firstHighFrameSize.y, lastHighFrameSize.y),
          z: Math.max(firstHighFrameSize.z, lastHighFrameSize.z),
        };
        if (lengthNum === LengthType.Length2) {
          positonAndSize.position.x = lastHighFramePosition.x;
          positonAndSize.position.z = (firstHighFramePosition.z
              - firstHighFrameSize.z / 2
              + (lastHighFramePosition.z + lastHighFrameSize.z / 2))
            / 2;
          positonAndSize.size.x = Math.max(
            firstHighFrameSize.x,
            lastHighFrameSize.x,
          );
          positonAndSize.size.z = firstHighFrameSize.z + lastHighFrameSize.z;
        }
      } else {
        positonAndSize.position = highFrameMeshs[0]?.getPosition();
        positonAndSize.size = highFrameMeshs[0]?.getModelSize();
      }
    // eslint-disable-next-line max-lines
    }
    return positonAndSize;
  }

  /**
   * @description: 当顶柜有高柜（只有顶柜长度比底柜大时顶柜才会有高柜），且高柜不与底柜相连，需要渲染高柜的左前右三块踢脚板
   * 处理Length1边的高柜踢脚板
   * @param {*} highFrameData 高柜模型中心点坐标和尺寸
   * @param {*} skirtingBoardTexture 踢脚线材质
   ** @param {*} lengthNum 渲染踢脚线的边
   * @param {*} doorDepth
   * @return {*}
   * @author: Zhanyu Shen
   */
  renderTopHighFrameSkirtingBoardLength1(
    highFrameData,
    skirtingBoardTexture,
    lengthNum = LengthType.Length1,
  ) {
    const highFrameFrontSideLength = highFrameData?.size?.x;
    const highFrameSkirtingBoard = [];

    // 新增高柜左面踢脚板
    const highFrameLeftPosition = {
      x:
        highFrameData?.position?.x
        + highFrameFrontSideLength / 2
        + SKIRTINGBOARDCONFIG.DEPTH / 2,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      // z: FRAMEDEPTH.BOTTOM / 2,
      z: highFrameData?.position?.z,
    };
    const highFrameLeftSize = {
      width: SKIRTINGBOARDCONFIG.DEPTH,
      height: SKIRTINGBOARDCONFIG.HEIGHT,
      depth: FRAMEDEPTH.BOTTOM,
    };
    const highFrameLeftSkirtingBoard = new SkirtingBoard(
      this.scene,
      highFrameLeftPosition,
      highFrameLeftSize,
    );
    highFrameLeftSkirtingBoard.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(highFrameLeftSkirtingBoard);
    highFrameSkirtingBoard.push(highFrameLeftSkirtingBoard);

    const highFrameFrontSizeZ = lengthNum === LengthType.Length3
      ? -highFrameData?.size?.z / 2
      : highFrameData?.size?.z / 2;

    // 新增高柜正面踢脚板
    const highFrameFrontPosition = {
      x: highFrameData?.position?.x - SKIRTINGBOARDCONFIG.DEPTH / 2,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      // z: FRAMEDEPTH.BOTTOM - SKIRTINGBOARDCONFIG.DEPTH / 2,
      z:
        highFrameData?.position?.z
        + highFrameFrontSizeZ
        + SKIRTINGBOARDCONFIG.DEPTH / 2,
    };
    const highFrameFrontSize = {
      width: highFrameFrontSideLength + SKIRTINGBOARDCONFIG.DEPTH,
      height: SKIRTINGBOARDCONFIG.HEIGHT,
      depth: SKIRTINGBOARDCONFIG.DEPTH,
    };
    const highFrameFrontSkirtingBoard = new SkirtingBoard(
      this.scene,
      highFrameFrontPosition,
      highFrameFrontSize,
    );
    highFrameFrontSkirtingBoard.shadowInfo = {
      width: highFrameFrontSideLength,
      lengthType: lengthNum,
      type: 'hightFrame',
    };
    highFrameFrontSkirtingBoard.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(highFrameFrontSkirtingBoard);
    highFrameSkirtingBoard.push(highFrameFrontSkirtingBoard);

    // 新增高柜右面踢脚板
    const highFrameRightPosition = {
      x:
        highFrameData?.position?.x
        - highFrameFrontSideLength / 2
        - SKIRTINGBOARDCONFIG.DEPTH,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      // z: FRAMEDEPTH.BOTTOM / 2,
      z: highFrameData?.position?.z,
    };
    const highFrameRightSkirtingBoard = new SkirtingBoard(
      this.scene,
      highFrameRightPosition,
      highFrameLeftSize,
    );
    highFrameRightSkirtingBoard.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(highFrameRightSkirtingBoard);
    highFrameSkirtingBoard.push(highFrameRightSkirtingBoard);

    return highFrameSkirtingBoard;
  }

  /**
   * @description: 当顶柜有高柜（只有顶柜长度比底柜大时顶柜才会有高柜），且高柜不与底柜相连，需要渲染高柜的左前右三块踢脚板
   * 处理Length2边的高柜踢脚板
   * @param {*} highFrameData 高柜模型中心点坐标和尺寸
   * @param {*} skirtingBoardTexture
   * @param {*} doorDepth
   * @return {*}
   * @author: Zhanyu Shen
   */
  renderTopHighFrameSkirtingBoardLength2(highFrameData, skirtingBoardTexture) {
    const highFrameFrontSideLength = highFrameData?.size?.z;
    const highFrameSkirtingBoard = [];

    // 新增高柜左面踢脚板
    const highFrameLeftPosition = {
      x: -FRAMEDEPTH.BOTTOM / 2,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      z: highFrameData?.position.z + highFrameFrontSideLength / 2,
    };
    const highFrameLeftSize = {
      width: FRAMEDEPTH.BOTTOM,
      height: SKIRTINGBOARDCONFIG.HEIGHT,
      depth: SKIRTINGBOARDCONFIG.DEPTH,
    };
    const highFrameLeftSkirtingBoard = new SkirtingBoard(
      this.scene,
      highFrameLeftPosition,
      highFrameLeftSize,
    );
    highFrameLeftSkirtingBoard.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(highFrameLeftSkirtingBoard);
    highFrameSkirtingBoard.push(highFrameLeftSkirtingBoard);

    // 新增高柜正面踢脚板
    const highFrameFrontPosition = {
      x: -SKIRTINGBOARDCONFIG.DEPTH / 2 - FRAMEDEPTH.BOTTOM,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      z: highFrameData?.position.z,
    };
    const highFrameFrontSize = {
      width: SKIRTINGBOARDCONFIG.DEPTH,
      height: SKIRTINGBOARDCONFIG.HEIGHT,
      depth: highFrameFrontSideLength,
    };
    const highFrameFrontSkirtingBoard = new SkirtingBoard(
      this.scene,
      highFrameFrontPosition,
      highFrameFrontSize,
    );
    highFrameFrontSkirtingBoard.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(highFrameFrontSkirtingBoard);
    highFrameSkirtingBoard.push(highFrameFrontSkirtingBoard);

    // 新增高柜右面踢脚板
    const highFrameRightPosition = {
      x: -FRAMEDEPTH.BOTTOM / 2,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      z: highFrameData?.position.z - highFrameFrontSideLength / 2,
    };
    const highFrameRightSkirtingBoard = new SkirtingBoard(
      this.scene,
      highFrameRightPosition,
      highFrameLeftSize,
    );
    highFrameRightSkirtingBoard.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(highFrameRightSkirtingBoard);
    highFrameSkirtingBoard.push(highFrameRightSkirtingBoard);

    return highFrameSkirtingBoard;
  }

  getSidePlateDepth(length, position = 'bottom') {
    let sidePlateDepth = 0;
    if (!this.templateJson[position] || !this.templateJson[position][length]) {
      return sidePlateDepth;
    }

    const sidePlates = this.templateJson.version > '2.2'
      ? this.templateJson[position][length]?.sidePlatesV2
      : this.templateJson[position][length]?.sidePlates;

    if (sidePlates && sidePlates.length > 0) {
      if (this.templateJson.version > '2.2') {
        const sidePlateMesh = this.scene.getMeshByName(
          sidePlates[0]?.componentBasic.id,
        );
        sidePlateDepth = new MeshManage(sidePlateMesh).getModelSize().z;
      } else {
        const sidePlateMesh = this.scene.getMeshByName(sidePlates[0]?.id);
        sidePlateDepth = new MeshManage(sidePlateMesh).getModelSize().z;
      }
    }
    return sidePlateDepth;
  }
}
export default RenderBaseType;
